<ng-container *transloco="let convert;">
  <!--      Begin Modal Layout Containers-->
  @if (this.contentDisplay === AdminModalDisplayEnum.FORM_TEMPLATE) {
    <ng-content *ngTemplateOutlet="formTemplate"></ng-content>
  }
  @if (this.contentDisplay === AdminModalDisplayEnum.RESULTS_TEMPLATE) {
    <ng-content *ngTemplateOutlet="resultsTemplate"></ng-content>
  }
  @if (this.contentDisplay === AdminModalDisplayEnum.ERROR_TEMPLATE) {
    <ng-content *ngTemplateOutlet="errorTemplate"></ng-content>
  }

  <!-- Begin Form Template-->
  <ng-template #formTemplate>
    <div
      class="modal--action-list"
      role="dialog"
      aria-modal="true"
      aria-labelledby="update-selected-modal-title"
      [attr.aria-label]="convert('sellModule.manageInventory.actionListModal.updateSelectedModal.ariaLabelUpdateSelectedModal')"
      [attr.data-track-region]="headline"
      >
      <header class="modal__header">
        <h1 class="modal__title" id="update-selected-modal-title" tabindex="-1">
          {{ headerText }}
        </h1>
      </header>

      <div class="modal__content">

        <div
          class="modal__body disclaimerSpacing"
          [attr.aria-label]="convert('sellModule.manageInventory.actionListModal.updateSelectedModal.ariaLabelVehicleNumberDisclaimer')">
          @if (!isMultipleVehicles) {
            <div class="vehicle-info__row"
              [innerHTML]="convert('sellModule.manageInventory.actionListModal.updateSelectedModal.textUpdateSingleVehicleNumberDisclaimer', {selectedVehicleCount : selectedVehicleCount})">
            </div>
          }

          @if (isMultipleVehicles) {
            <div class="vehicle-info__row"
              [innerHTML]="convert('sellModule.manageInventory.actionListModal.updateSelectedModal.textUpdateMultipleVehiclesNumberDisclaimer', {selectedVehicleCount : selectedVehicleCount})">
            </div>
          }
        </div>

        @if (isYellowLightAction || isVehicleStatusChangeAction) {
          <div
            class="modal__body"
            [attr.aria-label]="convert('sellModule.manageInventory.actionListModal.updateSelectedModal.ariaLabelUpdateSelected')">
            <div class="vehicle-info__row" [innerHtml]="selectingYesDisclaimerText">
            </div>
          </div>
        }

        @if (!this.isLoading) {
          <div>
            <form name="updateVehiclesForm" [formGroup]="updateVehiclesForm" class="updateVehiclesForm" nonvalidate>
              <div class="row">
                <div class="col-md-5">
                  <div class="form-group">
                    <label for="updateAction" class="label" [innerHTML]="convert('sellModule.manageInventory.actionListModal.updateSelectedModal.selectLabelAction')"></label>
                    <div class="select-wrapper">
                      <select formControlName="updateAction" id="updateAction" class="custom-select wrapText">
                        <option [ngValue]="defaultVehicleAction.value">{{convert('sellModule.posting.descriptionForm.textSelect')}}</option>
                        @for (action of possibleUpdateActions; track action) {
                          <option [ngValue]="action.value">{{action.name}}</option>
                        }
                      </select>
                    </div>
                  </div>
                  @if (isYellowLightAction && yellowLightOptionsSuccessfullyRetrieved) {
                    <div class="form-group">
                      @if (!isMultipleYellowLightsEnabled) {
                        <label for="yellowLights" class="label form-label fw-bold">{{convert('sellModule.manageInventory.actionListModal.updateSelectedModal.selectLabelYellowLight')}}</label>
                      }
                      @if (isMultipleYellowLightsEnabled) {
                        <label for="yellowLights" class="label form-label fw-bold">{{convert('sellModule.manageInventory.actionListModal.updateSelectedModal.selectLabelMultipleYellowLights')}}</label>
                      }
                      <app-multi-selector-dropdown [list]="yellowLightOptions" [isRequired]="true"
                        [multiSelectEnabled]="isMultipleYellowLightsEnabled">
                      </app-multi-selector-dropdown>
                    </div>
                  }
                  @if (isYellowLightError) {
                    <span class="required-item-error-message">
                      {{convert('sellModule.manageInventory.actionListModal.updateSelectedModal.errorYellowLightRetrieval')}}
                    </span>
                  }
                  @if (isVehicleStatusChangeAction) {
                    <div class="form-group">
                      <label for="vehicleStatus" class="label form-label fw-bold">{{convert('sellModule.manageInventory.actionListModal.updateSelectedModal.selectLabelVehicleStatus')}}</label>
                      <div class="select-wrapper">
                        <select formControlName="vehicleStatus" id="vehicleStatus"
                          [ngClass]="isVehicleStatusError ? 'custom-select wrapText is-invalid' :'custom-select wrapText'">
                          <option [ngValue]="defaultVehicleAction.value">{{convert('sellModule.posting.descriptionForm.textSelect')}}</option>
                          @for (status of vehicleStatusList; track status) {
                            <option [ngValue]="status.value">{{status.name}}</option>
                          }
                        </select>
                      </div>
                      @if (isVehicleStatusError) {
                        <span class="required-item-error-message fw-bold" data-test-id="select-vehicle-status-error">
                          {{convert('sellModule.manageInventory.actionListModal.updateSelectedModal.errorSelectVehicleStatus')}}
                        </span>
                      }
                    </div>
                  }
                  <!--            Change Applied to # vehicles -->
                  <span class="required-item-error-message fw-bold" data-test-id="total-vehicles-to-change-message">
                    {{ messageForVehicleNumberUpdate }}
                  </span>
                </div>
              </div>
            </form>
            <div class="modal__actions">
              <button
                class="btn btn-primary me-md-2 mb-3 mb-md-0"
                allytmln="Yes, Update"
                data-track-elem="button"
                data-track-name="Update Vehicles"
                [attr.aria-label]="convert('sellModule.manageInventory.actionListModal.updateSelectedModal.ariaLabelYesUpdate')"
                (click)="updateVehicles()">
                {{convert('sellModule.manageInventory.actionListModal.updateSelectedModal.ariaLabelYesUpdate')}}
              </button>
              <button
                class="btn cancel btn-link outline-focus ms-md-2"
                [attr.aria-label]="convert('sellModule.manageInventory.actionListModal.updateSelectedModal.textDontUpdate')"
                (click)="closeModal()">
                <span>{{convert('sellModule.manageInventory.actionListModal.updateSelectedModal.textDontUpdate')}}</span>
              </button>
            </div>
          </div>
        }
      </div>

      @if (this.isLoading) {
        <div class="spinner-container">
          <app-spinner></app-spinner>
        </div>
      }

      <div class="modal-close-container text-end">
        <button
          id="update-vehicles-modal-close"
          class="modal__close action_list_modal_close"
          aria-label="Close modal"
          (click)="closeModal()"
          data-track-elem="icon"
          data-track-name="close"
          data-track-trigger="close"
          >
          <i class="allycon-glyph-close text-primary" aria-hidden="true"></i>
        </button>
      </div>
    </div>
  </ng-template>
  <!--End Form Template -->

  <!--Begin Result Summary Template-->
  <ng-template #resultsTemplate>
    <div
      class="modal--action-list"
      role="dialog"
      aria-modal="true"
      aria-labelledby="update-selected-modal-title"
      [attr.aria-label]="convert('sellModule.manageInventory.actionListModal.updateSelectedModal.ariaLabelUpdateSelectedModal')"
      [attr.data-track-region]="headline"
      >
      <header class="modal__header">
        <h1 class="modal__title" id="update-selected-modal-title" tabindex="-1">
          {{updatedHeaderText}}
        </h1>
      </header>

      <div class="modal__content">

        <div
          class="modal__body bodyMinHeight"
          [attr.aria-label]="convert('sellModule.manageInventory.actionListModal.updateSelectedModal.ariaLabelUpdateSelected')">

          @if (isSuccessVins) {
            <div class="success-icon successVins summaryMessage summaryContainer">
              <div class="innerConatiner">
                <i class="allycon-success-fill text-success updateIcon" aria-hidden="true"></i>
              </div>
              <div class="innerConatiner">
                <span class="result_message">{{ successMessage }}</span>
                <strong>{{ successVins }}</strong>
              </div>
            </div>
          }

          @if (isFailureVins) {
            <div>
              @for (updateErrorDisplay of updateErrorDisplays; track updateErrorDisplay) {
                <div class="error-icon" class="updateErrorDisplay">
                  <div class="summaryContainer">
                    <div class="innerConatiner">
                      <i class="allycon-error-fill text-danger updateIcon" aria-hidden="true"></i>
                    </div>
                    <div class="innerConatiner">
                      <span class="result_message">{{ updateErrorDisplay.vins.length }}</span>
                      @if (updateErrorDisplay.vins.length === 1) {
                        <span>{{ failureLabelSingular }}</span>
                      }
                      @if (updateErrorDisplay.vins.length !== 1) {
                        <span>{{ failureLabelPlural }}</span>
                      }
                      <span>{{ templatePunctuation.parenthesis }}</span>
                      <span>{{ updateErrorDisplay.errorMessage }}</span>
                      <span>{{ templatePunctuation.closingParenthesis }}</span>
                      <span>{{ templatePunctuation.colonWithSpace }}</span>
                      <strong>{{ updateErrorDisplay.stringifiedVins }}</strong>
                    </div>
                  </div>
                </div>
              }
            </div>
          }
        </div>

        <div class="modal__actions">
          <button
            class="btn btn-primary me-md-2 mb-3 mb-md-0"
            [attr.aria-label]="convert('sellModule.manageInventory.actionListModal.updateSelectedModal.textDontUpdate')"
            (click)="closeModal()">
            <span>{{convert('sellModule.manageInventory.actionListModal.updateSelectedModal.close')}}</span>
          </button>
        </div>
      </div>

      @if (this.isLoading) {
        <div class="spinner-container">
          <app-spinner></app-spinner>
        </div>
      }

      <div class="modal-close-container text-end">
        <button
          id="update-vehicles-modal-close"
          class="modal__close action_list_modal_close"
          aria-label="Close modal"
          (click)="closeModal()"
          data-track-elem="icon"
          data-track-name="close"
          data-track-trigger="close"
          >
          <i class="allycon-glyph-close text-primary" aria-hidden="true"></i>
        </button>
      </div>
    </div>
  </ng-template>
  <!--End Result Summary Template -->

  <!--Start Error Template-->
  <ng-template #errorTemplate>
    <div
      class="modal--action-list"
      role="dialog"
      aria-modal="true"
      aria-labelledby="update-selected-modal-title"
      [attr.aria-label]="convert('sellModule.manageInventory.actionListModal.updateSelectedModal.ariaLabelUpdateSelectedModal')"
      [attr.data-track-region]="headline"
      >

      <header class="modal__header">
        <h1 class="modal__title" id="update-selected-modal-title" tabindex="-1">
          {{errorHeaderText}}
        </h1>
      </header>

      <div class="modal__content">
        <div class="summaryContainer">
          <span class="pt-1 pe-4"><app-error-icon [fill]="'#d42925'"></app-error-icon></span>
          {{ errorMessage }}
        </div>

        <div class="modal__actions">
          <button
            class="btn btn-primary me-md-2 mb-3 mb-md-0"
            [attr.aria-label]="convert('sellModule.manageInventory.actionListModal.updateSelectedModal.textDontUpdate')"
            (click)="closeModal()">
            <span>{{convert('sellModule.manageInventory.actionListModal.updateSelectedModal.close')}}</span>
          </button>
        </div>
      </div>

      <div class="modal-close-container text-end">
        <button
          id="update-vehicles-modal-close"
          class="modal__close action_list_modal_close"
          aria-label="Close modal"
          (click)="closeModal()"
          data-track-elem="icon"
          data-track-name="close"
          data-track-trigger="close"
          >
          <i class="allycon-glyph-close text-primary" aria-hidden="true"></i>
        </button>
      </div>
    </div>
  </ng-template>
  <!--End Error Template-->

</ng-container>
